import React, { Component } from 'react';

import { HashLink as Link } from 'react-router-hash-link';

import { name } from 'settings';
import { BackImage, StoreButtons } from 'C4';

import logo from 'assets/images/logo/logo_white.png';

// eslint-disable-next-line react/prefer-stateless-function
export default class EmbedSizzleView extends Component {
  render() {
    const registerSuccessful = localStorage.getItem('registerSuccessful');

    return (
      <div className="embedSizzleView">
        <BackImage id="760" darken />
        <div className="welcomeView__Wrapper">
          <div className="logoWelcome">
            <img src={logo} alt={name} />
          </div>
          <div className="welcomeView__Wrapper__Text">
            <iframe src="https://cdn.jwplayer.com/players/Kw8fPFtu-EuRqXXsO.html" width="100%" height="100%" frameborder="0" scrolling="auto" title="Sizzle"></iframe>
          </div>
        </div>
      </div>
    );
  }
}
